import React from 'react';
import pt from 'prop-types';

import SignupLayout from './layout';
import SignupVerifyCode from './verify-code';
import './signup.scss';

export default class VerifySignupPage extends React.PureComponent {
  static propTypes = {
    flash: pt.object,
    defaultCode: pt.string,
    onSubmitCode: pt.func,
    onResendEmail: pt.func,
  };

  render() {
    const { flash, defaultCode, onSubmitCode, onResendEmail } = this.props;

    return (
      <SignupLayout flash={flash}>
        <SignupVerifyCode
          defaultCode={defaultCode}
          onSubmitCode={onSubmitCode}
          onResendEmail={onResendEmail}
        />
      </SignupLayout>
    );
  }
}
